'use client';

import { BuilderComponent, useIsPreviewing } from '@builder.io/react';
import { builder } from '@builder.io/sdk';
import '@builder.io/widgets';
import { JSX } from 'react';

import './components/blocks';
import { BuilderResponse, BuilderPageData } from './serverUtils';

//TODO: abstract out builder init to config/secret

export interface BuilderPageProps {
    content: BuilderResponse<BuilderPageData>;
    modelName?: string;
    apiKey?: string;
    countryCode: string;
    data?: Record<string, unknown>;
}

// Using <Link/> was causing search pages to pre-fetch and trigger extra search events.
// Temporarily removing this until we come up with a long term solution.
// function CustomLink(props: any) {
//     return <Link {...props} />;
// }

export default function RenderBuilderContent({
    content,
    modelName = 'page',
    apiKey,
    countryCode,
    data,
}: BuilderPageProps): JSX.Element | undefined {
    if (!apiKey) {
        throw new Error('Builder API key is not provided.');
    }
    builder.init(apiKey);
    // eslint-disable-next-line react-hooks/immutability
    builder.apiVersion = 'v3';
    const isPreviewing = useIsPreviewing();

    const show404 = !content && !isPreviewing;

    if (!show404) {
        return <BuilderComponent content={content} model={modelName} locale={countryCode} data={data} />;
    } else {
        //notFound();
    }
}

export function setBuilderUserAttributes(options: Record<string, string | boolean>): void {
    builder.setUserAttributes(options);
}
